import { Modal } from 'antd';

import styled from 'styled-components';

export const ModalContainer = styled(Modal)<{ isConfirm?: boolean }>`
  .ant-modal-body {
    ${({ isConfirm }) => (isConfirm ? '' : 'height: 520px')};
    overflow-y: auto;
  }
`;

export const Container = styled.div`
  p {
    font-size: 14px;
    font-weight: 500;
    color: #202020;
  }
`;
